<template>
  <div class="rt-node">
    <!-- 头部 -->
    <div
      v-if="title || $slots.title"
      :class="computedNodeHeaderClass"
      class="node-header"
    >
      <div class="left">
        <slot name="icon">
          <div
            v-if="!small && isShowIcon"
            :class="computedNodeBgClass"
          >
            <rt-icon
              :name="icon"
              size="24"
            />
          </div>
          <div v-else />
        </slot>
        <slot name="title">
          <div class="title">
            {{ title }}
          </div>
        </slot>
      </div>
      <div class="right">
        <slot name="right" />
      </div>
    </div>

    <!-- 内容 -->
    <div
      :class="['node-content-' + paddingSize, contentWrapperClass]"
      :style="contentWrapperStyle"
      class="node-content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon.vue';
import xpcConfig from '../../config';

export default {
  name: 'RtNode',
  components: { RtIcon },
  props: {
    small: Boolean,
    showIcon: {
      type: Boolean,
      default: true
    },
    title: String,
    icon: {
      type: String,
      default: 'rt-base-orders_fill'
    },
    paddingSize: String,
    // 【节点】背景色
    iconBgColor: String,
    contentWrapperClass: String,
    contentWrapperStyle: Object
  },
  computed: {
    // 全局配置相当于一个默认属性，
    // 优先级：组件默认属性  < 全局配置属性 < 使用组件设置属性
    computedNodeHeaderClass () {
      const { small, paddingSize } = this;
      let classList = [];
      if (small) {
        classList.push('is-small');
      } else {
        if (xpcConfig.get('node.small')) {
          classList.push('is-small');
        }
      }
      if (paddingSize) {
        classList.push(`rt-xpc-node-header-${paddingSize}`);
      } else {
        if (xpcConfig.get('node.paddingSize')) {
          classList.push(`rt-xpc-node-header-${xpcConfig.get('node.paddingSize')}`);
        }
      }
      return classList;
    },
    //  【节点】背景色支持配置所有主题色及 light色的变量
    computedNodeBgClass () {
      const { iconBgColor } = this;
      let classList = ['node-icon'];
      if (iconBgColor) {
        classList.push(`rt-xpc-bg-${iconBgColor}`)
      }
      return classList;
    },
    isShowIcon () {
      return this.showIcon === false ? this.showIcon : xpcConfig.get('node.showIcon')
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtNode.vue?45af7a9b